module.exports = __webpack_public_path__ + "static/media/55_000053.16908203.jpg";